import { Component } from '@angular/core';

@Component({
  selector: 'app-schedule-pending-icon',
  imports: [],
  templateUrl: './schedule-pending-icon.html',
  styleUrl: './schedule-pending-icon.css'
})
export class SchedulePendingIcon {

}
